import { call, put, takeLatest } from "redux-saga/effects"

import { t } from "../../../i18next"

import {
  HOME_UPDATE_CURRENT_LOCATION_BEGIN,
  HOME_UPDATE_CURRENT_LOCATION_SUCCESS,
  HOME_UPDATE_CURRENT_LOCATION_FAILURE,
  HOME_UPDATE_CURRENT_LOCATION_DISMISS_ERROR,
} from "./constants"
import { uponMapMovement } from "./updateMapProps"

export function updateCurrentLocation() {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: HOME_UPDATE_CURRENT_LOCATION_BEGIN,
  }
}

export function dismissUpdateCurrentLocationError() {
  return {
    type: HOME_UPDATE_CURRENT_LOCATION_DISMISS_ERROR,
  }
}

const getCurrentLocation = () => {
  // Try HTML5 geolocation.
  if (navigator.geolocation) {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, maximumAge: 60000 }),
    )
      .then(position => {
        return {
          coords: position.coords,
          error: null,
        }
      })
      .catch(error => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            return { coords: null, error: t("home.allowLocationDetection") }
          case error.POSITION_UNAVAILABLE:
            return { coords: null, error: null }
          default:
            return { coords: null, error: null }
        }
      })
  } else {
    // Browser doesn't support Geolocation
    const error = t("home.noLocationSupport")
    console.log(error)
    return { coords: null, error }
  }
}

// worker Saga: will be fired on HOME_UPDATE_CURRENT_LOCATION_BEGIN actions
export function* doUpdateCurrentLocation() {
  const { coords, error } = yield call(getCurrentLocation)
  if (coords) {
    yield put({
      type: HOME_UPDATE_CURRENT_LOCATION_SUCCESS,
      data: coords,
    })
  } else {
    if (error) {
      yield put({
        type: HOME_UPDATE_CURRENT_LOCATION_FAILURE,
        data: {
          error: error,
          info: null,
        },
      })
    } else {
      yield put({
        type: HOME_UPDATE_CURRENT_LOCATION_FAILURE,
        data: {
          error: null,
          info: t("home.noLocationFound"),
        },
      })
    }
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchUpdateCurrentLocation() {
  yield takeLatest(HOME_UPDATE_CURRENT_LOCATION_BEGIN, doUpdateCurrentLocation)
}

// Redux reducer
export const reducer = (state, action) => {
  let newState
  switch (action.type) {
    case HOME_UPDATE_CURRENT_LOCATION_BEGIN:
      newState = {
        ...state,
        mapCenter: state.location || state.mapCenter,
        zoomLevel: Math.min(state.zoomLevel, 11),
        updateCurrentLocationPending: true,
        updateCurrentLocationError: null,
      }

      uponMapMovement(state, newState)

      return newState

    case HOME_UPDATE_CURRENT_LOCATION_SUCCESS:
      const { latitude, longitude, accuracy } = action.data
      const location = { lat: latitude, lng: longitude }

      newState = {
        ...state,
        location,
        accuracy,
        mapCenter: location,
        zoomLevel: closeUpZoom(accuracy, state.zoomLevel),
        updateCurrentLocationPending: false,
        updateCurrentLocationError: null,
        updateCurrentLocationInfo: null,
      }

      uponMapMovement(state, newState)

      return newState

    case HOME_UPDATE_CURRENT_LOCATION_FAILURE:
      return {
        ...state,
        updateCurrentLocationPending: false,
        updateCurrentLocationError: action.data.error,
        updateCurrentLocationInfo: action.data.info,
      }

    case HOME_UPDATE_CURRENT_LOCATION_DISMISS_ERROR:
      return {
        ...state,
        updateCurrentLocationError: null,
      }

    default:
      return state
  }
}

/*
 Zoom to show the whole area where the device might be located, plus a small margin;
 show no less than ca. 500 m radius, except when already zoomed in closer; show no more than all of Switzerland.
 It's only a rough heuristic! Actual Google Maps calculations differ and screen size is not taken into account.
*/
const MIN_AUTO_ZOOM = 7 // all of Switzerland
const MAX_AUTO_ZOOM = 17 // street names and individual buildings
const closeUpZoom = (accuracy, currentZoom) => {
  if (accuracy && currentZoom) {
    const optimumZoom = 100 / Math.log2((accuracy + 100) / 10)
    const maxZoom = Math.max(MAX_AUTO_ZOOM, currentZoom)

    return Math.ceil(Math.min(maxZoom, Math.max(optimumZoom, MIN_AUTO_ZOOM)))
  } else {
    return currentZoom
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/updateCurrentLocation.js